import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import "../styles/about.css";
 import aboutImg from "../images/about/about-1.jpeg";
import { IoCheckmarkCircleOutline } from "react-icons/io5";
import { MdArrowRightAlt } from "react-icons/md";
import { Link } from "react-router-dom";
import Meta from "./Meta";

const AboutUs = () => {

  return (
    <>

    <Container>
      <div className="about__us-section">
        <div className="about__content">
<h5 className="about__subtitle">ABOUT US</h5>

 
<h2 className="about__title"> Trusted <span>Car Dealership</span> in Kenya </h2>
<p>
  At <strong>Matel Trading Motors</strong>, we are proud to be one of Kenya’s most 
  trusted and reliable car dealerships. Our dedication to transparency, honesty, 
  and exceptional service has made us the preferred choice for car buyers across 
  the country.
</p>

<ul>
  <li>
    <IoCheckmarkCircleOutline className="checkmark-icon" />
    <span>
      A wide range of <strong>quality vehicles</strong> from top brands like Toyota, 
      Nissan, Honda, Subaru, BMW, and more.
    </span>
  </li>

  <li>
    <IoCheckmarkCircleOutline className="checkmark-icon" />
    <span>
      <strong>Professional guidance and honest pricing</strong> from our experienced 
      team, helping you make the right choice with confidence.
    </span>
  </li>

  <li>
    <IoCheckmarkCircleOutline className="checkmark-icon" />
    <span>
      <strong>Flexible payment options</strong> and financing plans tailored to 
      your needs.
    </span>
  </li>

  <li>
    <IoCheckmarkCircleOutline className="checkmark-icon" />
    <span>
      <strong>After-sale support and customer care</strong> that ensures your 
      satisfaction long after you drive away.
    </span>
  </li>
</ul>


          <div className="about__buttons">
            <Link to="/contact-us" className="btn btn-theme2">Contact Us <MdArrowRightAlt className="explore-icon"/></Link>
            <Link to="/about-us" className="btn btn-outline">Learn More <MdArrowRightAlt className="explore-icon"/></Link>
          </div>
        </div>

        {/* Rotating Image */}
        <div className="about__image">
          <img src={aboutImg} alt="About Us" />
        </div>
      </div>
    </Container>
    </>

  );
};

export default AboutUs;
